/**
 * Lifecycle of a form within one environment.
 *
 * Sign-off is not a status: a template is published so the client can see it,
 * and approved after that, so approval is recorded on the template's promotion
 * instead. The API dropped Approved and PendingApproval for the same reason.
 */
export enum FormStatus {
  Archived = 'archived',
  Draft = 'draft',
  Published = 'published'
}

